import { createFileRoute, useParams } from "@tanstack/react-router";
import { WarehouseDetailPage } from "@/components/inventory/WarehouseDetailPage";

export const Route = createFileRoute("/admin/_layout/inventory/warehouses_/$id")({
  component: AdminWarehouseDetail,
});

function AdminWarehouseDetail() {
  const { id } = useParams({ from: "/admin/_layout/inventory/warehouses_/$id" });
  return <WarehouseDetailPage warehouseId={id} />;
}
